module.exports = __webpack_public_path__ + "static/project-4-8e0ca7a4e0645b2cc7f523c2202cf891.jpg";